import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import {
  ProjectsActionTypes,
  UsersActionTypes,
  ChaptersActionTypes,
  VersionsActionTypes,
  PhotosActionTypes,
  BooksActionTypes,
  PackagesActionTypes,
} from '../../actions/types';

const fetchProjectById = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectById,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const createProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.createProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const deleteProjectById = makeAsyncReducerHandlers(
  ProjectsActionTypes.deleteProjectById,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items.filter(item => item._id !== action.payload.project._id),
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const toggleProjectArchivingById = makeAsyncReducerHandlers(
  ProjectsActionTypes.toggleProjectArchivingById,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  // TODO: implement helper findOneAndUpdate for logic below
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);

    if (index === -1) {
      items.push(project);
    } else {
      items.splice(index, 1, project);
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchDataToEditProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchDataToEditProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editProjectWithRelatedData = makeAsyncReducerHandlers(
  ProjectsActionTypes.editProjectWithRelatedData,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);

    if (index === -1) {
      items.push(project);
    } else {
      items.splice(index, 1, project);
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchChaptersAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchChaptersAndResourcesByUser = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchChaptersAndResourcesByUser,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getBookSampleAndResourcesByUser = makeAsyncReducerHandlers(
  ProjectsActionTypes.getBookSampleAndResourcesByUser,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProofDataByProjectId = makeAsyncReducerHandlers(
  ChaptersActionTypes.fetchProofDataByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProofDataByUserId = makeAsyncReducerHandlers(
  ChaptersActionTypes.fetchProofDataByUserId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByProjectId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchProjectOverviewDataByCustomerId = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchProjectOverviewDataByCustomerId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getDataForProjectsList = makeAsyncReducerHandlers(
  ProjectsActionTypes.getDataForProjectsList,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.projects,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);


const addWriterToProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.addWriterToProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);

    if (index === -1) {
      items.push(project);
    } else {
      items.splice(index, 1, project);
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getUserWithMiscData = makeAsyncReducerHandlers(
  UsersActionTypes.getUserWithMiscData,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.shouldLoadMoreProjects ? state.items.concat(action.payload.projects) : action.payload.projects,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);


const getDataToCompareVersions = makeAsyncReducerHandlers(
  VersionsActionTypes.getDataToCompareVersions,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchPhotosAndResources = makeAsyncReducerHandlers(
  PhotosActionTypes.fetchPhotosAndResources,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const moveToNextStageOfProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.moveToNextStageOfProject,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = [...state.items];
    const index = items.findIndex(item => item._id === project._id);
    const updatedProject = {
      ...items[index],
      stages: project.stages,
      timelineData: project.timelineData,
      composedTimelineData: project.composedTimelineData,
    };

    if (index === -1) {
      items.push(updatedProject);
    } else {
      items.splice(index, 1, updatedProject);
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const fetchTimelineDataByCustomer = makeAsyncReducerHandlers(
  ProjectsActionTypes.fetchTimelineDataByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const toggleUserEnableToEditDraft = makeAsyncReducerHandlers(
  ProjectsActionTypes.toggleUserEnableToEditDraft,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);
    const isCustomerEnableToEditDraft = project.isCustomerEnableToEditDraft ?? items[index]?.isCustomerEnableToEditDraft;
    const isWriterEnableToEditDraft = project.isWriterEnableToEditDraft ?? items[index]?.isWriterEnableToEditDraft;
    const isContentTeamEnableToEditDraft = project.isContentTeamEnableToEditDraft ?? items[index]?.isContentTeamEnableToEditDraft;
    const isDevelopmentalEditorEnableToEditDraft = project.isDevelopmentalEditorEnableToEditDraft ?? items[index]?.isDevelopmentalEditorEnableToEditDraft;
    const isProProofreaderEnableToEditDraft = project.isProProofreaderEnableToEditDraft ?? items[index]?.isProProofreaderEnableToEditDraft;

    if (index === -1) {
      items.push({
        ...items[index],
        isCustomerEnableToEditDraft,
        isWriterEnableToEditDraft,
        isContentTeamEnableToEditDraft,
        isDevelopmentalEditorEnableToEditDraft,
        isProProofreaderEnableToEditDraft,
      });
    } else {
      items.splice(index, 1, {
        ...items[index],
        isCustomerEnableToEditDraft,
        isWriterEnableToEditDraft,
        isContentTeamEnableToEditDraft,
        isDevelopmentalEditorEnableToEditDraft,
        isProProofreaderEnableToEditDraft,
      });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const toggleUserEnableToEditOutline = makeAsyncReducerHandlers(
  ProjectsActionTypes.toggleUserEnableToEditOutline,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);
    const isCustomerEnableToEditOutline = project.isCustomerEnableToEditOutline ?? items[index]?.isCustomerEnableToEditOutline;
    const isWriterEnableToEditOutline = project.isWriterEnableToEditOutline ?? items[index]?.isWriterEnableToEditOutline;

    if (index === -1) {
      items.push({ ...items[index], isCustomerEnableToEditOutline, isWriterEnableToEditOutline });
    } else {
      items.splice(index, 1, { ...items[index], isCustomerEnableToEditOutline, isWriterEnableToEditOutline });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const toggleUserEnableToDownloadOutline = makeAsyncReducerHandlers(
  ProjectsActionTypes.toggleUserEnableToDownloadOutline,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex((item) => item._id === project._id);
    const isCustomerEnableToDownloadOutline = project.isCustomerEnableToDownloadOutline
      ?? items[index]?.isCustomerEnableToDownloadOutline;

    if (index === -1) {
      items.push({ ...items[index], isCustomerEnableToDownloadOutline });
    } else {
      items.splice(index, 1, { ...items[index], isCustomerEnableToDownloadOutline });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getProjectsDataForExcel = makeAsyncReducerHandlers(
  ProjectsActionTypes.getProjectsDataForExcel,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getDataFromHubspot = makeAsyncReducerHandlers(
  ProjectsActionTypes.getDataFromHubspot,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const customerReviewedUpgrades = makeAsyncReducerHandlers(
  ProjectsActionTypes.customerReviewedUpgrades,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveBookDraftByCustomer = makeAsyncReducerHandlers(
  BooksActionTypes.approveBookDraftByCustomer,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editorSeenRequestForUpgrade = makeAsyncReducerHandlers(
  ProjectsActionTypes.editorSeenRequestForUpgrade,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);

    if (index === -1) {
      items.push({ ...items[index], ...project });
    } else {
      items.splice(index, 1, { ...items[index], ...project });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editorSendDraftToDevelopmentalEditor = makeAsyncReducerHandlers(
  BooksActionTypes.editorSendDraftToDevelopmentalEditor,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex((item) => item._id === project._id);
    const isWriterEnableToEditDraft = project.isWriterEnableToEditDraft ?? items[index]?.isWriterEnableToEditDraft;
    const isDevelopmentalEditorEnableToEditDraft = project.isDevelopmentalEditorEnableToEditDraft ?? items[index]?.isDevelopmentalEditorEnableToEditDraft;

    if (index === -1) {
      items.push({ ...items[index], isWriterEnableToEditDraft, isDevelopmentalEditorEnableToEditDraft });
    } else {
      items.splice(index, 1, { ...items[index], isWriterEnableToEditDraft, isDevelopmentalEditorEnableToEditDraft });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const editorSendDraftToProProofreader = makeAsyncReducerHandlers(
  BooksActionTypes.editorSendDraftToProProofreader,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex((item) => item._id === project._id);
    const isProProofreaderEnableToEditDraft = project.isProProofreaderEnableToEditDraft ?? items[index]?.isProProofreaderEnableToEditDraft;
    const isDevelopmentalEditorEnableToEditDraft = project.isDevelopmentalEditorEnableToEditDraft ?? items[index]?.isDevelopmentalEditorEnableToEditDraft;

    if (index === -1) {
      items.push({ ...items[index], isProProofreaderEnableToEditDraft, isDevelopmentalEditorEnableToEditDraft });
    } else {
      items.splice(index, 1, { ...items[index], isProProofreaderEnableToEditDraft, isDevelopmentalEditorEnableToEditDraft });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getProjectAndBookData = makeAsyncReducerHandlers(
  ProjectsActionTypes.getProjectAndBookData,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const cancelUpgradeRequest = makeAsyncReducerHandlers(
  ProjectsActionTypes.cancelUpgradeRequest,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);

    if (index === -1) {
      items.push({ ...items[index], ...project });
    } else {
      items.splice(index, 1, { ...items[index], ...project });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);
const completeUpgradeRequest = makeAsyncReducerHandlers(
  ProjectsActionTypes.completeUpgradeRequest,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { project } = action.payload;
    const items = Array.from(state.items);
    const index = items.findIndex(item => item._id === project._id);

    if (index === -1) {
      items.push({ ...items[index], ...project });
    } else {
      items.splice(index, 1, { ...items[index], ...project });
    }

    return {
      items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getDataForUpgradesByProjectId = makeAsyncReducerHandlers(
  PackagesActionTypes.getDataForUpgradesByProjectId,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const approveDraftByContentTeam = makeAsyncReducerHandlers(
  BooksActionTypes.approveDraftByContentTeam,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [action.payload.project],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getNextStageForProject = makeAsyncReducerHandlers(
  ProjectsActionTypes.getNextStageForProject,
  (state) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: [{ ...state.items[0], nextStage: action.payload.project.nextStage }],
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  getDataForProjectsList,
  fetchProjectOverviewDataByProjectId,
  fetchProjectOverviewDataByCustomerId,
  fetchProjectById,
  createProject,
  deleteProjectById,
  toggleProjectArchivingById,
  fetchChaptersAndResourcesByProjectId,
  fetchChaptersAndResourcesByUser,
  fetchDataToEditProject,
  editProjectWithRelatedData,
  fetchProofDataByProjectId,
  fetchProofDataByUserId,
  addWriterToProject,
  getUserWithMiscData,
  getDataToCompareVersions,
  fetchPhotosAndResources,
  moveToNextStageOfProject,
  fetchTimelineDataByCustomer,
  toggleUserEnableToEditDraft,
  toggleUserEnableToEditOutline,
  toggleUserEnableToDownloadOutline,
  getProjectsDataForExcel,
  customerReviewedUpgrades,
  getDataFromHubspot,
  approveBookDraftByCustomer,
  editorSeenRequestForUpgrade,
  editorSendDraftToDevelopmentalEditor,
  editorSendDraftToProProofreader,
  getBookSampleAndResourcesByUser,
  getBookSampleAndResourcesByProjectId,
  getProjectAndBookData,
  getDataForUpgradesByProjectId,
  cancelUpgradeRequest,
  completeUpgradeRequest,
  approveDraftByContentTeam,
  getNextStageForProject,
};
